module.exports = __webpack_public_path__ + "images/inclusion-flag.svg";